import { MQ_SMALL_ONLY, MQ_MIDLARGE, MQ_LARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { mediumSquare, smallSquare } = IMAGE_SIZES;

const base = {
  fallbackDims: mediumSquare,
  sourceSets: [
    {
      layoutWidth: { value: 319, units: 'px' },
      imageDims: mediumSquare,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 262, units: 'px' },
      imageDims: smallSquare,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 176, units: 'px' },
      imageDims: mediumSquare,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 350, units: 'px' },
      imageDims: mediumSquare,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: '(min-width: 0px)',
      ratio: 1
    }
  ]
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
